import { PaginationResponse } from "models/pagination-response";
import { IFilaEsperaPagedRequest } from "models/request/fila-espera-paged-request";
import { IFilaEsperaPagedResponse } from "models/response/fila-espera-paged-response";
import { ITipoFilaEsperaResponse } from "models/response/tipo-fila-espera-response";

export type FilasEsperaState = {
    filas: PaginationResponse<IFilaEsperaPagedResponse>;
    filaPagedRequest: IFilaEsperaPagedRequest;
    tipos: ITipoFilaEsperaResponse[];
    ultimaAtualizacao: string | null;
    loading: boolean;
    error: string | null;
};

export enum ACTION_TYPES {
    setFilas = 'setFilas',
    setFilaPagedRequest = 'setFilaPagedRequest',
    setTipos = 'setTipos',
    setUltimaAtualizacao = 'setUltimaAtualizacao',
    setLoading = 'setLoading',
    setError = 'setError',
}

export const FilasEsperaReducer = (state: FilasEsperaState, action: any): FilasEsperaState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setFilaPagedRequest:
            return { ...state, filaPagedRequest: payload };
        case ACTION_TYPES.setFilas:
            return { ...state, filas: payload };
        case ACTION_TYPES.setTipos:
            return { ...state, tipos: payload };
        case ACTION_TYPES.setUltimaAtualizacao:
            return { ...state, ultimaAtualizacao: payload };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: payload };
        case ACTION_TYPES.setError:
            return { ...state, error: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
